/**
 * getUrlKey 截取地址栏参数
 * @param value
 * @returns {String}
 */
function getUrlKey(name) {
    return (
        decodeURIComponent(
            (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
                location.href
            ) || [, ''])[1].replace(/\+/g, '%20')
        ) || null
    );
}

export default {
  getUrlKey,
};

// 静默刷新：移除地址所有查询参数
export function removeParams () {
  const url = new URL(window.location.href); // 获取当前 URL
  const hash = url.hash; // 获取锚点部分（例如 "#/gameStoreCenter"）
  if (hash.includes('?')) {
    // 去掉查询参数部分
    url.hash = hash.split('?')[0]; // 更新锚点
  }
  history.replaceState({}, '', url.toString());
}

